export default __webpack_public_path__ + "static/media/edit_icon.588c14cb.svg";